/* eslint-disable max-len */
const deTree = [
  {
    tag: 'EAR',
    // type: 'Please choose the affected ear',
    type: 'Ear',
    answer: 'START',
    question: 'affectedEar',
    buttons: [
      {
        label: 'LINKS',
        nextTag: 'ROOT',
      },
      {
        label: 'RECHTS',
        nextTag: 'ROOT',
      },
    ],
    links: [],
    head: 'Bitte wählen Sie das betroffene Ohr',
    body: '<span class="font-weight-bold">Bitte beachten:</span><br />Im Zuge der Kandidatenwahl sollte das kontralaterale Ohr (ggf. in versorgtem Zustand) immer berücksichtigt werden. Diese Anwendung kann sich jedoch immer nur auf ein Ohr fokussieren. Im Falle eines asymmetrischen Hörverlustes muss dessen Ursache vor der Wahl der Behandlungsmethode festgestellt werden.',
    component: 'DoubleChoice',
  },
  {
    tag: 'ROOT',
    parent: 'EAR',
    type: 'Audiological',
    answer: 'LINKS oder RECHTS',
    question: 'hearingLossType',
    buttons: [
      {
        label: 'CHL',
        nextTag: 'CHL1-1',
        title: 'Schallleitungsschwerhörigkeit',
        description: 'Der Begriff Schallleitungsschwerhörigkeit bezeichnet alle Probleme im Außen- oder Mittelohr, die die ordnungsgemäße Schallweiterleitung verhindern. Diese Art der Schwerhörigkeit ist in der Regel mit einem leichten oder mittleren Hörverlust im Bereich von 25 dB HL bis 65 dB HL verbunden.',
      },
      {
        label: 'MHL',
        nextTag: 'MHL1-1',
        title: 'Kombinierte Schwerhörigkeit',
        description: 'Bei einer kombinierten Schwerhörigkeit liegt sowohl eine Schallempfindungsschwerhörigkeit als auch eine Schallleitungsschwerhörigkeit vor. Ursachen dieser Art von Schwerhörigkeit sind Probleme sowohl im Innenohr als auch im Außen- oder Mittelohr.',
      },
      {
        label: 'SNHL',
        nextTag: 'SN-ROOT',
        title: 'Schallempfindungsschwerhörigkeit',
        description: 'Eine Schallempfindungsschwerhörigkeit entsteht durch fehlende oder beschädigte Sinneszellen (Haarzellen) in der Cochlea. Diese Art der Schwerhörigkeit bleibt in der Regel dauerhaft bestehen. Der Grad der Schallempfindungsschwerhörigkeit, die auch als Schallempfindungsstörung oder Innenohrschwerhörigkeit bezeichnet wird, reicht von leicht über mittel und schwer bis hin zu hochgradig.',
      },
      {
        label: 'SSD',
        nextTag: 'SSL1-1',
        title: 'Einseitige Taubheit',
        description: 'Einseitige Taubheit ist eine Art von Hörverlust, die nur in einem Ohr auftritt, während das andere Ohr normale Hörschwellen oder einen leichten Hörverlust aufweist. Patienten mit einseitiger Taubheit sind in der Wahrnehmung ihrer Umwelt oft erheblich eingeschränkt. Sprachverständlichkeit und Richtungshören können speziell in geräuschvoller Umgebung schwierig sein.',
      },
      {
        label: 'NHL',
        nextTag: 'NHL1-1',
        title: 'Neuraler Hörverlust',
        description: 'Neuraler Hörverlust kann auftreten, wenn der Hörnerv fehlt oder beschädigt ist. Es handelt sich dabei in der Regel um einen hochgradigen und dauerhaften Hörverlust. Hörgeräte und Cochlea-Implantate bringen keinen Nutzen, da der Hörnerv nicht in der Lage ist, genügend Schallinformationen an das Gehirn weiterzuleiten.',
      },
    ],
    links: [],
    head: 'Wählen Sie die Schwerhörigkeit',
    body: '',
    component: 'Selector',
  },
  {
    tag: 'SSL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'SSD',
    buttons: [
      {
        label: 'JA',
        nextTag: 'SSL2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'SSL2-2N',
      },
    ],
    links: [],
    body: 'Ist das betroffene Ohr hochgradig (schallempfindungs-) schwerhörig oder taub?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL2-1Y',
    parent: 'SSL1-1',
    type: 'Medical',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'SSL3-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'SSL3-2N',
      },
    ],
    links: [],
    body: 'Ist das KONTRALATERALE Ohr normalhörend oder im Bereich leichten Hörverlustes und ohne retrocochleäre und zentrale Hörstörungen?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL2-2N',
    parent: 'SSL1-1',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Auf der Grundlage der bereitgestellten Informationen liegt der Kandidat nicht innerhalb der Kriterien der einseitigen Taubheit. Bitte wählen Sie einen anderen Hörverlusttyp durch Drücken der Home-Taste unten oder wenden Sie sich an Ihren nächsten MED-EL-Vertreter für weitere Unterstützung in diesem Fall.',
    component: 'Conclusion',
  },
  {
    tag: 'SSL3-1Y',
    parent: 'SSL2-1Y',
    type: 'Medical',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'SSL4-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'SSL4-2N',
      },
    ],
    links: [],
    body: 'Liegt eine Schädigung des Hörnervs auf dem betroffenen Ohr vor?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL3-2N',
    parent: 'SSL2-1Y',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'SSL4-3Y',
      },
      {
        label: 'NEIN',
        nextTag: 'SSL4-4N',
      },
    ],
    links: [],
    body: 'Liegt das KONTRALATERALE Ohr im Bereich geringgradiger oder mittelgradiger Schwerhörigkeit, ohne retrocochleäre und zentrale Hörstörungen?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL4-3Y',
    page: 'SSD=CI',
    parent: 'SSL3-2N',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'CI-System',
        solution: 'Cochlea-Implantat',
        href: 'https://www.medel.com/de/cochlear-implants',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres und leichtem bis mittlerem Hörverlust auf der kontralateralen Seite<br />• Ermöglicht binaurales Hören<br />• Nervenfasern in der gesamten Cochlea werden durch elektrische Impulse direkt stimuliert<br />• Weiche und flexible Elektroden ermöglichen die feinen Strukturen der Cochlea zu erhalten<br />• Eine der Hörphysiologie ähnliche Stimulation des Innenohres ermöglicht einen nahezu natürlichen Höreindruck.',
        image: 'ci',
      },
    ],
    head: 'Bitte bedenken Sie, dass für Kandidaten mit einseitiger Ertaubung ein ausführliches Vorgespräch über den Nutzen essentiell ist.<br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-4N',
    parent: 'SSL3-2N',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Auf der Grundlage der bereitgestellten Informationen liegt der Kandidat nicht innerhalb der Kriterien der einseitigen Taubheit. Bitte wählen Sie einen anderen Hörverlusttyp durch Drücken der Home-Taste unten oder wenden Sie sich an Ihren nächsten MED-EL-Vertreter für weitere Unterstützung in diesem Fall.',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-1Y',
    page: 'SSD=A+BB+ABI',
    parent: 'SSL3-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres und normalen Hörschwellen auf der kontralateralen Seite <br />• Freier Gehörgang<br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres mit normalen Hörschwellen auf der kontralateralen Seite <br />• Optimale Schallleitung durch direkte Stimulation <br />• Freier Gehörgang durch direkte Stimulation des Innenohrs <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'bonebridge',
      },
      {
        label: 'ABI',
        solution: 'Auditorisches-Hirnstamm-Implantat-System',
        href: 'https://www.medel.com/de/candidacy-criteria-for-hearing-implants/#NFII',
        description: '<ul><li>Die einzige Hörlösung für Personen welche aufgrund eines geschädigten Hörnervs nicht von einem Cochleaimplantat profitieren können.</li><li>Personen ab 12 Monaten welche aufgrund eines geschädigten Hörnervs nicht von einem Cochleaimplantat profitieren können. Mögliche Gründe für einen geschädigten Hörnerv:</li><ul><li>Kongenital aufgrund einer</li><ul><li>Aplasie des Hörnervs oder</li><li>Hypoplasie des Hörnervs </li></ul><li>Im Laufe des Lebens aufgetreten durch</li><ul><li>Schädigung des Hörnervs durch ein Schädeltrauma oder</li><li>eines andersartigen Tumors als NF2 oder</li><li>eine starke Ossifikation der Cochlea</li></ul></ul><li>An NF2 erkrankte Personen ab 15 Jahren</li></ul>',
        image: 'abi',
      },
    ],
    head: 'Bitte bedenken Sie, dass für Kandidaten mit einseitiger Ertaubung ein ausführliches Vorgespräch über den Nutzen essentiell ist.<br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-2N',
    page: 'SSD=CI+BB+A',
    parent: 'SSL3-1Y',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [
      {
        label: 'CI-System',
        solution: 'Cochlea-Implantat',
        href: 'https://www.medel.com/de/cochlear-implants',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres und normalem Hörvermögen oder leichtem bis mittlerem Hörverlust auf der kontralateralen Seite<br />• Ermöglicht binaurales Hören<br />• Nervenfasern in der gesamten Cochlea werden durch elektrische Impulse direkt stimuliert<br />• Weiche und flexible Elektroden ermöglichen es die feinen Strukturen der Cochlea zu erhalten <br />• Eine der Hörphysiologie ähnliche Stimulation des Innenohres ermöglicht einen nahezu natürlichen Höreindruck',
        image: 'ci',
      },
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres und normalen Hörschwellen auf der kontralateralen Seite <br />• Freier Gehörgang<br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Menschen mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit des betroffenen Ohres mit normalen Hörschwellen auf der kontralateralen Seite <br />• Optimale Schallleitung durch direkte Stimulation des Knochens <br />• Freier Gehörgang <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'bonebridge',
      },
    ],
    head: 'Bitte bedenken Sie, dass für Kandidaten mit einseitiger Ertaubung ein ausführliches Vorgespräch über den Nutzen essentiell ist.<br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen: <br />',
    component: 'Conclusion',
  },
  {
    tag: 'MHL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'MHL',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL2-2N',
      },
    ],
    addInfo: 'Schwankungen von weniger als 15 dB (sinkend oder steigend innerhalb der letzten 2 Jahre)',
    links: [],
    body: 'Sind die Knochenleitungswerte stabil *?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL2-1Y',
    parent: 'MHL1-1',
    type: 'Audiological',
    image: 'BB_IND_01',
    reference: 'Candidacy Guidelines page 12',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL3-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL3-2N',
      },
    ],
    links: [],
    body: 'Sind die Knochenleitungswerte kleiner oder gleich 45 dBHL bei 500 - 4000 Hz?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL2-2N',
    parent: 'MHL1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NEIN',
    buttons: [
      {
        label: 'Fortsetzen',
        nextTag: 'MHL2-1Y',
      },
    ],
    links: [],
    body: 'Wenn der Hörverlust mindestens 15 dB (in den letzten 2 Jahren steigend oder fallend) schwankt, sind die meisten Implantatlösungen kontraindiziert. Daher können herkömmliche Hörgeräte eine Lösung sein, bis sich der Hörverlust stabilisiert. Weitere medizinische Untersuchungen könnten in Betracht gezogen werden.',
    component: 'SingleChoice',
  },
  {
    tag: 'MHL3-1Y',
    parent: 'MHL2-1Y',
    type: 'Audiological',
    reference: 'Candidacy Guidelines page 12',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL4-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL4-2N',
      },
    ],
    addInfo: 'Unterschied zwischen Luftleitungswerten und Knochenschallleitungswerten',
    links: [],
    body: 'Ist der Abstand zwischen Luft- und Knochenleitung * bei 500 - 4000 Hz größer oder gleich 30 dB?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL3-2N',
    parent: 'MHL2-1Y',
    type: 'Audiological',
    image: 'VSB_CHL_IND_01',
    reference: 'Candidacy Guidelines page 12',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL4-3Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL4-4N',
      },
    ],
    links: [],
    body: 'Liegen die Knochenleitungswerte in diesem erweiterten schattierten Bereich?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-1Y',
    parent: 'MHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL5-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL5-2N',
      },
    ],
    links: [],
    body: 'Besteht eine akute Mittelohrentzündung?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-2N',
    parent: 'MHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL5-3Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL5-4N',
      },
    ],
    links: [],
    body: 'Besteht eine akute Mittelohrentzündung?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-3Y',
    parent: 'MHL3-2N',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL5-5Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL5-6N',
      },
    ],
    links: [],
    body: 'Besteht eine akute Mittelohrentzündung?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-4N',
    parent: 'MHL3-2N',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn die Knochenleitungswerte der kombinierten Schwerhörigkeit nicht den in der Grafik dargestellten Bereich entsprechen, sind MED-EL Mittelohrimplantate und Knochenleitungsimplantate nicht indiziert. Um einen potenziellen Hörgeräte- oder Cochlea-Implantat-Kandidaten zu beurteilen, wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL5-1Y',
    parent: 'MHL4-1Y',
    type: 'Medical',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL6-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL6-2N',
      },
    ],
    links: [],
    body: 'Kann eine retrocochleäre und zentrale Hörstörung ausgeschlossen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-2N',
    parent: 'MHL4-1Y',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL6-3Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL6-4N',
      },
    ],
    links: [],
    body: 'Kann eine retrocochleäre und zentrale Hörstörung ausgeschlossen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-3Y',
    parent: 'MHL4-2N',
    type: 'Medical',
    reference: 'Candidacy Guidelines, page 11',
    answer: 'JA',
    buttons: [{
      label: 'Fortsetzen',
      nextTag: 'MHL5-4N',
    }],
    links: [],
    body: 'Bei einem kombinierten Hörverlust mit einer akuten Mittelohrentzündung ist eine Behandlung und Beseitigung der Pathologie erforderlich, bevor eine Implantation in Betracht gezogen werden kann.',
    component: 'SingleChoice',
  },
  {
    tag: 'MHL5-4N',
    parent: 'MHL4-2N',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL6-5Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL6-6N',
      },
    ],
    links: [],
    body: 'Kann eine retrocochleäre und zentrale Hörstörung ausgeschlossen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-5Y',
    parent: 'MHL4-3Y',
    type: 'Medical',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL6-7Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL6-8N',
      },
    ],
    links: [],
    body: 'Kann eine retrocochleäre und zentrale Hörstörung ausgeschlossen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-6N',
    parent: 'MHL4-3Y',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'MHL6-9Y',
      },
      {
        label: 'NEIN',
        nextTag: 'MHL6-10N',
      },
    ],
    links: [],
    body: 'Kann eine retrocochleäre und zentrale Hörstörung ausgeschlossen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL6-1Y',
    page: 'MHL=VSB+BB',
    parent: 'MHL5-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Kandidaten mit leichter Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente von 30dB oder größer<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'bonebridge',
      },
    ],
    head: 'Aus audiologischer Sicht können sowohl VIBRANT SOUNDBRIDGE als auch BONEBRIDGE in Betracht gezogen werden. Ein Mittelohrimplantat ist nur dann eine Option, wenn die Mittelohrentzündung abgeheilt ist. Sollten Sie sich für ein Knochenleitungsimplantat entscheiden, ziehen Sie bitte die Möglichkeit in betracht, dass das kontralaterale Ohr beinflusst werden könnte.<br /><br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-2N',
    parent: 'MHL5-1Y',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörnerv geschädigt ist und / oder eine Schädigung der oberen Hörbahn vorliegt, ist dies eine Kontraindikation für ein Cochlea-, Mittelohr- oder Knochenleitungsimplantat im betroffenen Ohr. Für weitere Informationen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-3Y',
    page: 'MHL=VSB+BB',
    parent: 'MHL5-2N',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• unauffällige Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Kandidaten mit leichter Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente von 30dB oder größer<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'bonebridge',
      },
    ],
    head: 'Sollten Sie sich für ein Knochenleitungsimplantat entscheiden, ziehen Sie bitte die Möglichkeit in Betracht, dass das kontralaterale Ohr beeinflusst werden könnte. Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-4N',
    parent: 'MHL5-2N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörnerv geschädigt ist und / oder eine Schädigung der oberen Hörbahn vorliegt, ist dies eine Kontraindikation für ein Cochlea-, Mittelohr- oder Knochenleitungsimplantat im betroffenen Ohr. Für weitere Informationen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-5Y',
    page: 'MHL=VSB',
    parent: 'MHL5-4N',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Innenohres <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'vsb',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-6N',
    parent: 'MHL5-4N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörnerv geschädigt ist und / oder eine Schädigung der oberen Hörbahn vorliegt, ist dies eine Kontraindikation für ein Cochlea-, Mittelohr- oder Knochenleitungsimplantat im betroffenen Ohr. Für weitere Informationen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-7Y',
    page: 'MHL=VSB',
    parent: 'MHL5-5Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente <br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'vsb',
      },
    ],
    head: 'Aus audiologischer Sicht ist die VIBRANT SOUNDBRIDGE eine mögliche Lösung. Ein Mittelohrimplantat ist nur dann eine Option, wenn die Mittelohrentzündung abgeheilt ist.<br /><br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-8N',
    parent: 'MHL5-5Y',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörnerv geschädigt ist und / oder eine Schädigung der oberen Hörbahn vorliegt, ist dies eine Kontraindikation für ein Cochlea-, Mittelohr- oder Knochenleitungsimplantat im betroffenen Ohr. Für weitere Informationen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-9Y',
    page: 'MHL=VSB',
    parent: 'MHL5-6N',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'vsb',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-10N',
    parent: 'MHL5-6N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörnerv geschädigt ist und / oder eine Schädigung der oberen Hörbahn vorliegt, ist dies eine Kontraindikation für ein Cochlea-, Mittelohr- oder Knochenleitungsimplantat im betroffenen Ohr. Für weitere Informationen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'CHL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'Candidacy guidelines Implantable hearing Loss Solutions, page 10 ',
    answer: 'CHL',
    buttons: [
      {
        label: 'JA',
        nextTag: 'CHL2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'CHL3-1Y',
      },
    ],
    addInfo: 'Eine Verbesserung des Hörvermögens wird durch konventionelle medizinische Behandlung erwartet ',
    links: [],
    body: 'Ist der Hörverlust vorübergehend *?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL2-1Y',
    page: 'CHL=A',
    parent: 'CHL1-1',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit temporärer oder chronischer Erkrankung des Mittelohrs <br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
    ],
    body: 'Damit der Patient einen subjektiven Nutzen eines Knochenleitungshörsystems wahrnimmt, sollte eine Schallleitungskomponente von mindestens 25dB vorhanden sein. Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL3-1Y',
    parent: 'CHL1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'CHL4-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'CHL5-4N',
      },
    ],
    addInfo: 'Unterschied zwischen Luftleitungswerten und Knochenschallleitungswerten',
    links: [],
    body: 'Ist die  Differenz zwischen Luft- und Knochenleitung  * bei 500 - 4000 Hz größer oder gleich 30 dB?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL4-1Y',
    parent: 'CHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines – Implantable Hearing Loss Solutions page 11',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'CHL5-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'CHL5-2N',
      },
    ],
    links: [],
    body: 'Gibt es chronische Mittelohrentzündungen?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL5-1Y',
    page: 'CHL=A+BB',
    parent: 'CHL4-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit chronischen Erkrankungen des Mittelohrs <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'bonebridge',
      },
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit temporärer oder chronischer Erkrankung des Mittelohrs <br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
    ],
    head: 'Für Kandidaten mit Schallleitungsschwerhörigkeit und chronischer Mittelohrentzündung ist eine Rekonstruktion oder Mittelohroperation meist die erste Wahl der Behandlung. Aus audiologischer Sicht sind sowohl ADHEAR, VIBRANT SOUNDBRIDGE als auch BONEBRIDGE mögliche Hörlösungen. Ein Mittelohrimplantat ist nur dann eine Option, wenn die Mittelohrentzündung abgeheilt ist.<br /><br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL5-2N',
    page: 'CHL=A+BB',
    parent: 'CHL4-1Y',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Kandidaten mit leichter und mittlerer Innenohrschwerhörigkeit und einer anhaltenden Schallleitungskomponente<br />• Natürliches Hören durch direkte Stimulation des Knochens <br />• Freier Gehörgang<br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren ',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Knochenleitungsimplantat-System',
        href: 'https://www.medel.com/de/bonebridge/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit chronischen Erkrankungen des Mittelohrs <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'bonebridge',
      },
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit temporärer oder chronischer Erkrankung des Mittelohrs <br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL5-4N',
    page: 'CHL=A',
    parent: 'CHL3-1Y',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [
      {
        label: 'JA',
        nextTag: 'CHL6-3Y',
      },
      {
        label: 'NEIN',
        nextTag: 'CHL6-4N',
      },
    ],
    links: [],
    body: 'Gibt es chronische Mittelohrentzündungen?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL6-3Y',
    page: 'CHL=VSB+A',
    parent: 'CHL5-4N',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Patienten mit Schallleitungsschwerhörigkeit <br />• Natürliches Hören durch direkte Stimulation des Innenohrs <br />• Freier Gehörgang <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'vsb',
      },
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit temporärer oder chronischer Erkrankung des Mittelohrs <br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
    ],
    head: 'Für Kandidaten mit Schallleitungsschwerhörigkeit und chronischer Mittelohrentzündung ist eine Rekonstruktion oder Mittelohroperation meist die erste Wahl der Behandlung. Aus audiologischer Sicht sind  VIBRANT SOUNDBRIDGE und ADHEAR mögliche Hörlösungen. Ein Mittelohrimplantat ist nur dann eine Option, wenn die Mittelohrentzündung abgeheilt ist. Damit der Patient einen subjektiven Nutzen eines Knochenleitungshörsystems wahrnimmt, sollte eine Schalleitungskomponente von mindestens 25 dB vorhanden sein.<br />Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL6-4N',
    page: 'CHL=VSB+A',
    parent: 'CHL5-4N',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Patienten mit Schallleitungsschwerhörigkeit <br />• Natürliches Hören durch direkte Stimulation des Innenohrs <br />• Freier Gehörgang <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'vsb',
      },
      {
        label: 'ADHEAR',
        solution: 'Implantationsfreies Knochenleitungshörsystem',
        href: 'https://www.medel.com/de/adhear/',
        description: '• Ideal für Kinder und Erwachsene mit Fehlbildungen des Außenohrs <br />• Ideal für Kinder und Erwachsene mit temporärer oder chronischer Erkrankung des Mittelohrs <br />• Implantationsfreie Hörlösung ohne Altersberschränkung <br />• Kein Druck auf die Haut <br />• Kosmetisch ansprechend',
        image: 'adhear',
      },
    ],
    head: 'Für Kandidaten mit Schallleitungsschwerhörigkeit und chronischer Mittelohrentzündung ist eine Rekonstruktion oder Mittelohroperation meist die erste Wahl der Behandlung. Aus audiologischer Sicht sind  VIBRANT SOUNDBRIDGE und ADHEAR mögliche Hörlösungen. Damit der Patient einen subjektiven Nutzen eines Knochenleitungshörsystems wahrnimmt, sollte eine Schalleitungskomponente von mindestens 25dB vorhanden sein.<br /> Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'SN-ROOT',
    parent: 'ROOT',
    type: 'Audiological',
    image: 'VSB_SNHL_IND_01.png, CI_SNHL_IND_01.png, EAS_SNHL_IND_01.jpg',
    answer: 'SNHL',
    buttons: [
      {
        label: '1',
        nextTag: 'S1L1-1',
        image: 'VSB_SNHL_IND_01.png',
      },
      {
        label: '2',
        nextTag: 'S2L1-1',
        image: 'CI_SNHL_IND_01.png',
      },
      {
        label: '3',
        nextTag: 'S3L1-1',
        image: 'EAS_SNHL_IND_01.jpg',
      },
    ],
    links: [],
    head: 'Welcher schattierte Bereich enthält die Luftleitungswerte?',
    body: null,
    component: 'Selector',
  },
  {
    tag: 'S1L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Indications)',
    answer: 'SNHL (VSB)',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S1L2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S1L2-2N',
      },
    ],
    links: [],
    body: 'Gibt es einen medizinischen Grund, konventionelle Hörgeräte nicht zu verwenden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L2-1Y',
    parent: 'S1L1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S1L3-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S1L3-2N',
      },
    ],
    addInfo: 'Schwankungen von weniger als 20 dB (sinkend oder steigend innerhalb der letzten 2 Jahre)',
    links: [],
    body: 'Ist der Hörverlust stabil *?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L2-2N',
    parent: 'S1L1-1',
    type: 'Audiological',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Hörgeräte sollten als Erstbehandlung getestet werden. Bei unzureichendem Erfolg von konventionellen Hörgeräten kann ein Mittelohrimplantat in Betracht gezogen werden. ',
    component: 'Conclusion',
  },
  {
    tag: 'S1L3-1Y',
    parent: 'S1L2-1Y',
    type: 'Audiological',
    answer: 'JA',
    buttons: [
      {
        label: 'Fortsetzen',
        nextTag: 'S1L4-1Y',
      },
    ],
    links: [],
    body: 'Die Sprachverständlichkeitsschwelle könnte nützlich sein, um die audiologischen Befunde zu bestätigen.',
    component: 'SingleChoice',
  },
  {
    tag: 'S1L3-2N',
    parent: 'S1L2-1Y',
    type: 'Conclusion',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörverlust mindestens 15 dB (in den letzten 2 Jahren steigend oder fallend) schwankt, sind die meisten Implantatlösungen kontraindiziert. Daher können herkömmliche Hörgeräte eine Lösung sein, bis sich der Hörverlust stabilisiert. Weitere medizinische Untersuchungen könnten in Betracht gezogen werden. ',
    component: 'Conclusion',
  },
  {
    tag: 'S1L4-1Y',
    parent: 'S1L3-1Y',
    type: 'Medical',
    reference: '28084_20_Selection Criteria Card EN',
    answer: 'Fortsetzen',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S1L5-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S1L5-2N',
      },
    ],
    links: [],
    head: 'Sind die folgenden Kriterien erfüllt?',
    body: 'Sprachverständnis ist unversorgt besser als 50% beim offenen Wörtertest mit Kopfhörern, bei angenehmer Laustärke,<br /><br />UND<br /><br />Der Kandidat profitiert von der Verstärkung, was darauf hinweist, dass keine retrocochleäre und / oder zentralen Hörstörungen vorliegen. ',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L5-1Y',
    page: 'SNHL=VSB',
    parent: 'S1L4-1Y',
    type: 'Conclusion',
    reference: '28084_20_Selection Criteria Card EN',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Mittelohrimplantat-System',
        href: 'https://www.medel.com/de/vibrant-soundbridge/',
        description: '• Ideal für Menschen mit mittlerer bis schwerer Innenohrschwerhörigkeit<br />• Einzige Behandlungsmöglichkeit für Patienten die konventionelle Hörgeräten nicht tragen können <br />• Freier Gehörgang <br />• Unauffälliger Audioprozessor mit hohem Tragekomfort <br />• Intakte Haut - keine Hautirritationen <br />• Geeignet für Personen ab 5 Jahren',
        image: 'vsb',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'S1L5-2N',
    parent: 'S1L4-1Y',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn die geforderten Kriterien nicht erfüllt werden, fällt die Person bei sensorineuraler Schwerhörigkeit nicht in den Indikationsbereich für die VIBRANT SOUNDBRIDGE. Bitte wählen Sie eine andere Art von Hörverlust durch Drücken der Home-Taste unten oder kontaktieren Sie Ihren nächsten MED-EL-Vertreter für weitere Unterstützung in diesem Fall.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions, page 5',
    answer: 'SNHL (CI)',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S2L3-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S2L2-2N',
      },
    ],
    links: [],
    body: 'Wurden optimal angepasste Hörgeräte verwendet?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L2-2N',
    parent: 'S2L1-1',
    type: 'Audiological',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'MED-EL empfiehlt dringend, mindestens drei Monate lang optimal angepasste Hörgeräte zu verwenden, bevor Sie sich für eine Implantation entscheiden. Wenn jedoch ein Kandidat durch eine Infektionskrankheit ertaubte, was zu einer Verknöcherung führen kann und wenn Anzeichen einer Cochlea-Ossifikation vorliegen, kann es sein, dass ein Hörgerät nicht benötigt wird. In diesen Fällen sollte die Implantation normalerweise nicht verzögert werden.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L3-1Y',
    parent: 'S2L1-1',
    type: 'Medical',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions, page 5',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S2L4-1Y',
      },
      {
        label: 'KEIN bis WENIG',
        nextTag: 'S2L4-2N',
      },
    ],
    addInfo: 'Aktueller Gebrauch eines akustischen Hörgeräts, von durchschnittlich mindestens 4 Stunden pro Tag, während der letzten 3 Monate oder länger',
    links: [],
    body: 'Ist ein ausreichender Nutzen durch akustische Verstärkung vorhanden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L4-1Y',
    parent: 'S2L3-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [],
    body: 'Ein ausreichender Nutzen durch akustische Verstärkung schließt die Notwendigkeit einer Implantation zu dem gegebenen Zeitpunkt aus. Wenn sich das Hören verschlechtert oder wenn keine altersgerechten Fortschritte im Laufe der Zeit auftreten, kann eine weitere Beurteilung erforderlich sein. Bei weiteren Fragen wenden Sie sich bitte an Ihren nächsten MED-EL-Vertreter.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L4-2N',
    parent: 'S2L3-1Y',
    type: 'Medical',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'KEIN bis WENIG',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S2L5-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'NHL2-1Y',
      },
    ],
    links: [],
    body: 'Funktionieren der Hörnerv und die obere Hörbahn?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L5-1Y',
    parent: 'S2L4-2N',
    type: 'Medical',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S2L6-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S2L6-2N',
      },
    ],
    links: [],
    body: 'Ist die Cochlea vollständig entwickelt?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L6-1Y',
    page: 'SNHL=CI',
    parent: 'S2L5-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'CI-System',
        solution: 'Cochlea-Implantat',
        href: 'https://www.medel.com/de/cochlear-implants',
        description: '• Ideal für Menschen jeden Alters mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit<br />• Nervenfasern in der gesamten Cochlea werden durch elektrische Impulse direkt stimuliert<br />• Weiche und flexible Elektroden ermöglichen die feinen Strukturen der Cochlea zu erhalten<br />• Eine der Hörphysiologie ähnliche Stimulation des Innenohres ermöglicht einen nahezu natürlichen Höreindruck.',
        image: 'ci',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'S2L6-2N',
    parent: 'S2L5-1Y',
    type: 'Conclusion',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'NEIN',
    buttons: [
      {
        label: 'Fortsetzen',
        nextTag: 'S2L7-1A',
      },
    ],
    links: [],
    body: 'MED-EL bietet eine breite Palette von Implantatlösungen für verschiedene Anatomien. Die Verwendung eines (geeigneten) Implantats sollte vor der Operation bei anatomischen Anomalien der Cochlea sorgfältig abgewogen werden.',
    component: 'SingleChoice',
  },
  {
    tag: 'S2L7-1A',
    page: 'SNHL=CI',
    parent: 'S2L6-2N',
    type: 'Conclusion',
    answer: 'Fortsetzen',
    buttons: [],
    links: [
      {
        label: 'CI-System',
        solution: 'Cochlea-Implantat',
        href: 'https://www.medel.com/de/cochlear-implants',
        description: '• Ideal für Menschen jeden Alters mit schwerer bis hochgradiger Schallempfindungsschwerhörigkeit<br />• Nervenfasern in der gesamten Cochlea werden durch elektrische Impulse direkt stimuliert<br />• Weiche und flexible Elektroden ermöglichen die feinen Strukturen der Cochlea zu erhalten<br />• Eine der Hörphysiologie ähnliche Stimulation des Innenohres ermöglicht einen nahezu natürlichen Höreindruck.',
        image: 'ci',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'S3L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'SNHL (EAS)',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S3L2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S3L2-2N',
      },
    ],
    addInfo: 'Schwankungen von weniger als 20 dB (sinkend oder steigend innerhalb der letzten 2 Jahre)',
    links: [],
    body: 'Ist der Hörverlust stabil *?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L2-1Y',
    parent: 'S3L1-1',
    type: 'Audiological',
    reference: 'Candidacy Guidelines, Implantable Hearing Loss Solutions, page 7',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S3L3-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S3L3-2N',
      },
    ],
    links: [],
    body: 'Ist das einsilbige Wortverständnis bei 65 dBHL bei bester Hörgerteversorgung gleich oder schlechter als 60%?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L2-2N',
    parent: 'S3L1-1',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn der Hörverlust um mehr als 15 dB (in den letzten 2 Jahren steigend oder fallend) schwankt, sind die meisten Implantatlösungen kontraindiziert. Weitere medizinische Untersuchungen könnten in Betracht gezogen werden.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L3-1Y',
    parent: 'S3L2-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines, Implantable Hearing Loss Solutions, page 7',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S3L4-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S3L4-2N',
      },
    ],
    links: [],
    body: 'Ist die Cochlea frei von Fehlbildungen oder Obstruktionen?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L3-2N',
    parent: 'S3L2-1Y',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn das Sprachverständnis bei 65 dBHL besser als 60% ist, könnte ein Hörgerät zum gegebenen Zeitpunkt als die am besten geeignete Lösung angesehen werden.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L4-1Y',
    parent: 'S3L3-1Y',
    type: 'Medical',
    answer: 'JA',
    buttons: [
      {
        label: 'JA',
        nextTag: 'S3L5-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'S3L5-2N',
      },
    ],
    addInfo: 'Es gibt keine Pathologien des Außenohrs, die die Verwendung eines Hörgeräts verhindern',
    links: [],
    body: 'Kann ein herkömmliches Hörgerät getragen werden?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L4-2N',
    parent: 'S3L3-1Y',
    type: 'Medical',
    reference: 'IFU: Mi1200 SYNCHRONY / Cochlear Implant / page: 7',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Wenn anatomische Anomalien vorhanden sind, verhindert dies eine geeignete Platzierung des Stimulatorgehäuses im Schädelknochen oder der gewählten Elektrodenanordnung in der Cochlea. Die Verwendung eines Implantats sollte vor der Operation sorgfältig abgewogen werden.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L5-1Y',
    page: 'SNHL=EAS',
    parent: 'S3L4-1Y',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'EAS-System',
        solution: 'Elektrisch-akustische Stimulation',
        href: 'https://www.medel.com/de/eas-hearing-implant-system',
        description: '• Ideal für Personen mit partiellem Hörverlust <br />• Weiche und flexible Elektroden helfen das natürliche Resthörvermögen zu erhalten <br />• Gemeinsame Anwendung von zwei Technologien mit nur einem Audioprozessor: die akustische Verstärkung, wie bei einem Hörgerät, und die elektrische Stimulation der Cochlea durch das Cochleaimplantat ',
        image: 'eas',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'S3L5-2N',
    parent: 'S3L4-1Y',
    type: 'Medical',
    answer: 'NEIN',
    buttons: [
      {
        label: 'Fortsetzen',
        nextTag: 'S3L6-1A',
      },
    ],
    links: [],
    body: 'Akute Erkrankungen des äußeren Gehörgangs sollten vor der Implantation behandelt werden. Chronische Pathologien des äußeren Gehörgangs können die Platzierung und Verwendung eines Hörgeräts verhindern.',
    component: 'SingleChoice',
  },
  {
    tag: 'S3L6-1A',
    page: 'SNHL=EAS',
    parent: 'S3L5-2N',
    type: 'Conclusion',
    answer: 'Fortsetzen',
    buttons: [],
    links: [
      {
        label: 'EAS-System',
        solution: 'Elektrisch-akustische Stimulation',
        href: 'https://www.medel.com/de/eas-hearing-implant-system',
        description: '• Ideal für Personen mit partiellem Hörverlust <br />• Weiche und flexible Elektroden helfen das natürliche Resthörvermögen zu erhalten <br />• Gemeinsame Anwendung von zwei Technologien mit nur einem Audioprozessor: die akustische Verstärkung, wie bei einem Hörgerät, und die elektrische Stimulation der Cochlea durch das Cochleaimplantat ',
        image: 'eas',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'NHL1-1',
    parent: 'ROOT',
    type: 'Medical',
    answer: 'NHL',
    buttons: [
      {
        label: 'JA',
        nextTag: 'NHL2-1Y',
      },
      {
        label: 'NEIN',
        nextTag: 'NHL2-2N',
      },
    ],
    links: [],
    body: 'Ist der Hörnerv nicht funktionsfähig oder wird erwartet, dass er durch einen chirurgischen Eingriff funktionslos wird?',
    component: 'DoubleChoice',
  },
  {
    tag: 'NHL2-1Y',
    page: 'ABI',
    parent: 'NHL1-1',
    type: 'Conclusion',
    answer: 'JA',
    buttons: [],
    links: [
      {
        label: 'ABI',
        solution: 'Auditorisches-Hirnstamm-Implantat-System',
        href: 'https://www.medel.com/de/candidacy-criteria-for-hearing-implants/#NFII',
        description: '<ul><li>Die einzige Hörlösung für Personen welche aufgrund eines geschädigten Hörnervs nicht von einem Cochleaimplantat profitieren können.</li><li>Personen ab 12 Monaten welche aufgrund eines geschädigten Hörnervs nicht von einem Cochleaimplantat profitieren können. Mögliche Gründe für einen geschädigten Hörnerv:</li><ul><li>Kongenital aufgrund einer</li><ul><li>Aplasie des Hörnervs oder</li><li>Hypoplasie des Hörnervs </li></ul><li>Im Laufe des Lebens aufgetreten durch</li><ul><li>Schädigung des Hörnervs durch ein Schädeltrauma oder</li><li>eines andersartigen Tumors als NF2 oder</li><li>starke Ossifikation der Cochlea</li></ul></ul><li>An NF2 erkrankte Personen ab 15 Jahren</li></ul>',
        image: 'abi',
      },
    ],
    body: 'Durch die zur Verfügung gestellten Informationen ergeben sich folgende mögliche Hörlösungen:',
    component: 'Conclusion',
  },
  {
    tag: 'NHL2-2N',
    parent: 'NHL1-1',
    type: 'Conclusion',
    answer: 'NEIN',
    buttons: [],
    links: [],
    body: 'Basierend auf den zur Verfügung gestellten Informationen entspricht der Kandidat nicht den Kriterien für das auditorische Hirnstammimplantat (ABI). Bitte wählen Sie einen anderen Hörverlusttyp durch Drücken der Home-Taste unten oder wenden Sie sich an Ihren nächsten MED-EL-Vertreter für weitere Unterstützung in diesem Fall.',
    component: 'Conclusion',
  },
];

export default deTree;
